import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Card, CardContent, Button, CardActions } from '@material-ui/core';
import Feedback from '../../components/Feedback/Feedback';

// Define component styling
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
    },
    card: {
        width: '100%',
        maxWidth: 500,
        textAlign: 'center',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    cardHeader: {
        backgroundColor: '#fff',
        padding: theme.spacing(2),
        borderBottom: '1px solid #ddd',
    },
    title: {
        fontSize: 20,
        fontWeight: 600,
    },
    cardBody: {
        padding: theme.spacing(3),
    },
    message: {
        marginBottom: theme.spacing(3),
        fontSize: 18,
        fontWeight: 'bold',
        color: '#79232e'
    },
    cardFooter: {
        padding: theme.spacing(2),
        borderTop: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'space-between',
    },
    buttonPlaceOrder: {
        fontSize: '14px',
        textTransform: 'capitalize',
        borderRadius: '100px',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        backgroundColor: '#79232e',
        fontWeight: 700,
        color: '#fff',
        '&:hover': {
            color: '#fff',
            backgroundColor: '#a12e3d'
        },
        '&:active': {
            color: '#fff',
            backgroundColor: '#79232e'
        },
        '&:focus': {
            color: '#fff',
            backgroundColor: '#79232e'
        }
    },
    buttonBack: {
        fontSize: '14px',
        textTransform: 'capitalize',
        borderRadius: '100px',
        paddingLeft: '2rem',
        paddingRight: '2rem',
        backgroundColor: '#fff',
        fontWeight: 700,
        color: '#79232e',
        border: '1px solid #a52a2a',
        '&:hover': {
            color: '#fff',
            backgroundColor: '#a12e3d',
            border: '1px solid #79232e'
        },
        '&:active': {
            color: '#fff',
            backgroundColor: '#79232e',
            border: '1px solid #79232e'
        },
        '&:focus': {
            color: '#fff',
            backgroundColor: '#79232e',
            border: '1px solid #79232e'
        }
    }
}));

const VerifyOrder = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Card className={classes.card}>
                {/* Card Body */}
                <CardContent className={classes.cardBody}>
                    {props.submit === true && (
                        <Feedback message={props.message} complete={props.complete} />
                    )}
                </CardContent>
            </Card>
        </div>
    );
};

VerifyOrder.propTypes = {
    submit: PropTypes.bool.isRequired,
    message: PropTypes.string,
    complete: PropTypes.bool,
    onBack: PropTypes.func.isRequired,
    onPlaceOrder: PropTypes.func.isRequired,
};

export default VerifyOrder;
